// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"b83a4307","783":"c5924251"}[chunkId] + ".chunk.css";
};